import { Nullable } from "shared/lib/typeCheck.lib";

type DebugWindow = typeof window & {
  __DEBUG__: Record<string, unknown>;
};

export const logger = <T>(key: Nullable<string>, value: Nullable<T>, updater?: (prev: undefined | T) => T | void) => {
  if (!__DEV__ || __PROD__ || !key) return;

  const debugWindow = window as DebugWindow;

  if (!debugWindow.__DEBUG__) {
    debugWindow.__DEBUG__ = {};
  }

  if (updater) {
    const updatedValue = updater(debugWindow.__DEBUG__[key] as T | undefined);
    if (typeof updatedValue !== "undefined") {
      debugWindow.__DEBUG__[key] = updatedValue;
    }
    return;
  }

  if (value !== null && typeof value !== "undefined") {
    debugWindow.__DEBUG__[key] = value;
  }
};
